import * as angular from 'angular';
import { SanitizerService } from './sanitizer.service';

export const sanitizerServiceModule = angular.module('sanitizerServiceModule', [])
	.service('sanitizerService', SanitizerService)
	.name;
